import sortData from './sort-data';

// eslint-disable-next-line no-restricted-globals
onmessage = function listener(e) {
  const message = JSON.parse(e.data);
  const result = sortData(message);
  postMessage(result);
};
